var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    tabIndex: 0,
    "aria-label": "Copy digital giveaway url ",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Copy url") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.671 1.664H9.342a1.667 1.667 0 0 0-1.665 1.665v4.344H3.334A1.667 1.667 0 0 0 1.67 9.338v11.328a1.667 1.667 0 0 0 1.665 1.665h11.337a1.667 1.667 0 0 0 1.665-1.665V16.33h4.335a1.667 1.667 0 0 0 1.665-1.665V3.329a1.667 1.667 0 0 0-1.665-1.665m-5.665 19.002a.336.336 0 0 1-.335.335H3.334A.336.336 0 0 1 3 20.666V9.338a.336.336 0 0 1 .335-.335h4.343v5.662a1.667 1.667 0 0 0 1.665 1.665h5.664zm6-6a.336.336 0 0 1-.335.335H9.342a.336.336 0 0 1-.335-.335V3.329a.336.336 0 0 1 .335-.335h11.33a.336.336 0 0 1 .334.335z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d6da1e2c7bd36d94bde15c9cc53cd460.svg";
export { ForwardRef as ReactComponent };